import React from 'react';
import { Col, Row } from 'reactstrap';
import Readstories from './readStories';


const donationReach = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden' }} >


		<h2 className="text-heading-giveAssured" >Making sure your donations reach the right people</h2>
		<p>While it is difficult to verify every donation made through us, we verify a random sample for every program for every listed program.</p>
		<p>Verification visits are conducted by randomly identifying  two or more beneficiaries of a program from the reports that have been sent by the nonprofits. Our team then visit the beneficiary, usually directly without prior information. Checks are conducted on	</p>
		<Row>
			<Col xs="12" sm="12" md="8" lg="8">
			<ul>
				<li><p> If the beneficiary exists  </p></li>
			<li>	<p> She has received the benefits as described in the feedback report</p></li>
				</ul>
			</Col>
			<Col xs="12" sm="12" md="4" lg="4" className="main-box d-flex justify-content-center align-self-center">

				<p ><a href="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/sample-verification-questionnaire-CHINAR.jpg" target="_blank">Look at a sample verification questionnaire</a></p>

			</Col>
		</Row>
		<p><b>What happens if a nonprofit does not meet our requirements?</b></p>
		<p>If a nonprofit does not meet our requirements at the initial due diligence stage, we will not list their programs on our platform</p>
		<p><b>If the verification of an active program fails, it could be because of the below few reasons</b></p>
		<ul>
	<li>	<p>  because the beneficiary does not exist</p></li>
	<li>	<p>  the benefits given to him as described in the feedback report are found to be false. </p></li>
</ul>
		<p>We seek clarification from the nonprofit partner and also schedule a follow-up verification visit for a secondary visit. If even after the revisit, the nonprofit fails to show credible evidence or correct its process & procedures, then the NGO will be deactivated.
		</p>
		<Readstories />


		<style global jsx>
			{
				`

      .main-box{
        background-color: #f5f5f5;
        border: 1px solid #f5f5f5;
      font-weight: 400;

      border-radius: 4px;
      padding: 1rem;
      };

			`
			}
		</style>

	</Col>


);

export default donationReach;
